import script from "./SubmitEntryView.vue?vue&type=script&setup=true&lang=ts"
export * from "./SubmitEntryView.vue?vue&type=script&setup=true&lang=ts"

import "./SubmitEntryView.vue?vue&type=style&index=0&id=340cbcd2&scoped=true&lang=css"

import exportComponent from "E:\\Sites\\mk64\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-340cbcd2"]])

export default __exports__